import { api_react_v1_create_or_update_external_marketing_modal_path } from '@routes';

import request from './request';

export interface MarketingModalCreateOrUpdateRequest {
  external_source_id: string;
  external_source: string;
  button_text?: string;
  created_at?: string;
  custom_url?: string;
  disclosure?: string;
  guid?: string;
  header?: string;
  highlighted_cta?: string;
  id?: string;
  modal_type?: string;
  name?: string;
  newsletter_id?: number;
  offer_id?: string;
  subtitle?: string;
  title?: string;
  updated_at?: string;
}

export interface MarketingModalCreateOrUpdateResponse {
  button_text: string;
  custom_url: string;
  external_source_id: string;
  guid: string;
  header: string;
  id: string;
  modal_type: string;
  name: string;
  subtitle: string;
  title: string;
}

export async function createOrUpdateExternalMarketingModal(
  requestData: MarketingModalCreateOrUpdateRequest
): Promise<MarketingModalCreateOrUpdateResponse> {
  const res = await request(
    'post',
    api_react_v1_create_or_update_external_marketing_modal_path(),
    requestData
  );
  return res;
}
